'use client';

import { useState, useEffect } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Partner {
    id: number;
    name: string;
    logo: string;
    alt: string;
    category: string;
    verified: boolean;
}

const partners: Partner[] = [
    {
        id: 1,
        name: 'Lileon International',
        logo: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?auto=format&fit=crop&w=300&q=80",
        alt: 'Lileon International Business Office',
        category: 'Placement & Services',
        verified: true
    },
];

export default function PartnershipsSection() {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return (
            <section className="py-20 bg-surface/30">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-center">
                        <div className="w-full max-w-sm h-64 bg-surface rounded-xl animate-pulse" />
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="py-24 bg-surface/30">
            <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-7">
                <div className="text-center mb-16">
                    <h2 className="text-4xl sm:text-5xl font-bold text-text-primary mb-6">
                        Strategic <span className="gradient-text">Partnership</span>
                    </h2>
                    <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                        We have tied up with <strong>Lileon International</strong> to enhance our placement opportunities and educational services, ensuring our students get the best career kickstart.
                    </p>
                </div>

                <div className="flex justify-center mb-12">
                    {partners.map((partner, index) =>
                        <div
                            key={partner.id}
                            className="glass glass-border rounded-2xl p-8 hover-lift transition-smooth group w-full max-w-sm"
                            style={{
                                animation: 'fadeIn 0.6s ease-out forwards',
                                animationDelay: `${index * 100}ms`,
                                opacity: 0
                            }}>

                            <div className="relative h-48 mb-6 overflow-hidden rounded-xl border border-white/10">
                                <AppImage
                                    src={partner.logo}
                                    alt={partner.alt}
                                    className="w-full h-full object-cover transition-smooth group-hover:scale-110" />

                                {partner.verified &&
                                    <div className="absolute top-3 right-3 w-8 h-8 bg-success rounded-full flex items-center justify-center shadow-glow z-10">
                                        <Icon name="CheckBadgeIcon" size={18} variant="solid" className="text-white" />
                                    </div>
                                }
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                                <div className="absolute bottom-3 left-3">
                                    <span className="px-3 py-1 text-xs font-semibold bg-primary/20 text-primary border border-primary/20 rounded-full backdrop-blur-md">
                                        {partner.category}
                                    </span>
                                </div>
                            </div>

                            <h3 className="text-2xl font-bold text-text-primary text-center group-hover:text-primary transition-smooth mb-2">
                                {partner.name}
                            </h3>
                            <p className="text-center text-text-secondary text-sm">
                                Exclusive Placement Partner
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}